import React, { useState } from 'react';
import './Layout.scss';
import NavbarHeaderNew from "components/Header/NavbarHeaderNew";
import NavbarHeader from "components/Header/NavbarHeader";
interface LayoutProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ className = '', contentClassName = '', children }) => {
  // const logOut = () => {
  //   sessionStorage.removeItem('token')
  //   localStorage.removeItem('token')
  //   window.location.href = '/dang-nhap'
  // }
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <>
      <div className={`app menu-collapsed ${className} app-numerology ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`} >
        <div className='app-main'>
          <NavbarHeader></NavbarHeader>
          {/* <Header /> */}
          <div className="container" data-container-main >
            <div className="layout-wrapper">
              <NavbarHeaderNew 
                isSidebarCollapsed={isSidebarCollapsed}
                setIsSidebarCollapsed={setIsSidebarCollapsed}
              />
              <div className="sidebar__backdrop"></div>
              <div className={`page ${contentClassName}`} >
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Layout;
